import React,{useState} from 'react';
import {Link} from 'react-router-dom';


const ForgotPasswordForm = (props) => {
    const [email, setEmail] = useState({ value:'', error: '', isRequired: false });
  
      const validation = () => {
        let regex = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
        let formIsValid = true

        if (!email.value) {
            formIsValid = false
            let msg = "Please enter your email"
            setEmail({...email,error:msg})
        }
        if(email.value && (email.value.length < 13) || email.value && (email.value.length > 64)){
            formIsValid = false
            let msg = "Max 64 Character Length Min 3 Character Length"
            setEmail({...email,error:msg})
        }
        if(email.value && !(regex.test(email.value))){
            formIsValid = false
            let msg = "Enter a valid Email ID (Ex: abc@gmail.com)"
            setEmail({...email,error:msg})
        }

        if(formIsValid){
            setEmail({...email,error:''})
        }
        return formIsValid
    }

      const onSubmit = (e) => {
        e.preventDefault();
        if(validation()){
            const data = {
                email: email.value
            }
            props.onSubmit(data)
        }
        
    }

  return (
    <form onSubmit={onSubmit}>
    <div className="row">
        <div className="col-lg-12 mb-3">
            <div className="form-floating">
            <input
                type="text"
                className="form-control"
                name="email"
                placeholder="Email"
                value={email.value}
                onChange={(e) => setEmail({...email,value:e.target.value,error:''})}
            />
                <label>Email address</label> 
            </div>
            {email.error.length>0 &&<div className='invalidFeedback'>{email.error}</div>}

        </div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 mb-3 text-start">
            {props.loading ? (<button type="submit" disabled className="btn btn-primary btn-lg auth_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Sending ...</button>) : 
                <button type="submit" className="btn btn-primary btn-lg auth_btn">Send</button>
            }
            
        </div>
        
        <div className="col-lg-12 ">
            <p className="mb-0"> 
                <Link to="/login"> &nbsp;Back to login</Link>
            </p>
        </div>

    </div>
    </form>
  )
}

export default ForgotPasswordForm
